import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../../services/api';
import { ISubscriptionPrices } from './interfaces';

export const GET_SUBSCRIPTION_PRICES_THUNK_PREFIX = 'account/getSubscriptionPrices';
export const getSubscriptionPrices: AsyncThunk<ISubscriptionPrices | void, void, ThunkAPI> =
  createAsyncThunk(
    GET_SUBSCRIPTION_PRICES_THUNK_PREFIX,
    async (_data, thunk) => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        const response = await basicApiAsyncThunkCreator<ISubscriptionPrices | void, undefined>({
          endpoint: 'subscription/prices',
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Get,
          contentType: 'application/json'
        })(undefined, thunk);
        return response;
      } catch (err) {
        return thunk.rejectWithValue(err);
      }
    }
  );